<template>
  <div>
    <div
      class="announcement-content-small"
      v-for="contract in rentalUnit.Rate?.ContractsModels"
      :key="contract.id"
    >
      <div>
        <ion-row
          class="ion-justify-content-between ion-align-items-center price-subtitle nowrap"
          v-if="!contract.paymentCycle?.toLowerCase().includes('unknown')"
        >
          <div>
            <h3 class="font-sm bold-medium grey">{{ t('announcement.contractModel') }}</h3>
            <ion-row class="ion-justify-content-start ion-align-items-center price-subtitle nowrap">
              <p>{{ contract.paymentCycle }}</p>
            </ion-row>
          </div>
        </ion-row>
        <ion-row
          class="ion-justify-content-between ion-align-items-center price-subtitle nowrap"
          v-if="contract.Details && contract.Details.length > 0"
        >
          <div>
            <h3 class="font-sm bold-medium grey">{{ t('announcement.terms') }}</h3>
            <ion-row class="ion-justify-content-start ion-align-items-center price-subtitle nowrap">
              <p>{{ getContractTerms(contract.Details) }}</p>
            </ion-row>
          </div>
        </ion-row>
      </div>
    </div>
    <ion-row
      v-if="rentalUnit.Property && rentalUnit.Property.cancellationPolicy"
      class="ion-justify-content-between ion-align-items-center price-subtitle nowrap"
    >
      <div>
        <h1 class="font-md bold-medium ion-padding-bottom">
          {{ t(`announcement.policy.title`) }}
        </h1>
        <p>{{ t(`announcement.policy.${rentalUnit.Property.cancellationPolicy}.1`) }}</p>
      </div>
    </ion-row>
  </div>
</template>

<script setup lang="ts">
  import { IonRow } from '@ionic/vue';
  import { Detail, RentalUnit } from '@/interfaces/elastic/elastic.interface';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const props = withDefaults(
    defineProps<{
      rentalUnit: RentalUnit;
      language: string;
    }>(),
    {},
  );

  const getContractTerms = (details: Detail[]) => {
    const locale = details.find(
      (detail: Detail) => detail.Language.code.toLowerCase() === props.language.toLowerCase(),
    );

    return locale ? locale.detail : details[0].detail;
  };
</script>

<style lang="css" scoped></style>
